import React from 'react';
import { Mail } from 'lucide-react';
import { GithubIcon, LinkedinIcon, TwitterIcon, InstagramIcon, FacebookIcon } from './SocialIcons';
import { useAboutSocials } from '../hooks/useAbout';

const SOCIAL_DEFS = [
  { key: 'github',    label: 'GitHub',    fallback: 'https://github.com/rupeshbhatta',      Icon: GithubIcon },
  { key: 'linkedin',  label: 'LinkedIn',  fallback: 'https://linkedin.com/in/rupeshbhatta', Icon: LinkedinIcon },
  { key: 'twitter',   label: 'Twitter',   fallback: 'https://twitter.com/rupeshbhatta',     Icon: TwitterIcon },
  { key: 'instagram', label: 'Instagram', fallback: 'https://instagram.com/rupeshbhatta',   Icon: InstagramIcon },
  { key: 'facebook',  label: 'Facebook',  fallback: 'https://facebook.com/rupeshbhatta',    Icon: FacebookIcon },
  { key: 'email',     label: 'Email',     fallback: 'mailto:rupesh.bhatta1234@gmail.com',   Icon: Mail },
];

export default function Footer() {
  const cmsSocials = useAboutSocials();

  const socials = SOCIAL_DEFS.map(({ key, label, fallback, Icon }) => ({
    label, Icon,
    href: (key === 'email' ? null : cmsSocials[key]) || fallback,
  }));

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <span className="footer-brand">rb<span>.</span>dev</span>

        <div className="footer-socials">
          {socials.map(({ label, href, Icon }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith('mailto') ? undefined : '_blank'}
              rel="noreferrer noopener"
              className="social-icon-btn"
              aria-label={label}
              title={label}
            >
              <Icon size={16} />
            </a>
          ))}
        </div>

        <span className="footer-copy">
          &copy; {new Date().getFullYear()} Rupesh Bhatta
        </span>
      </div>
    </footer>
  );
}
